import { Box } from '@mui/material';

export default function NavLogo({ logo, onClick, variant }) {
    const isMd = variant === 'md';
    const imgStyle = { maxWidth: isMd ? 240 : 168, maxHeight: isMd ? 60 : 56, objectFit: 'scale-down' };

    const style = {
        display: { xs: isMd ? 'none' : 'flex', md: isMd ? 'flex' : 'none' },
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        cursor: 'pointer',
        minWidth: isMd ? 200 : 160,
        px: 4,
        mx: isMd ? 0 : 'auto',
        backgroundImage: theme => `linear-gradient(110deg, ${theme.palette.secondary?.main} 10%, ${theme.palette.white?.light} 10.5%, ${theme.palette.white?.light} 89.5%, ${theme.palette.primary?.main} 90%)`
    };

    return (
        <Box onClick={onClick} sx={style}>
            <img src={logo} alt="logo" style={imgStyle} />
        </Box>
    );
} 